const C = {
  name: "Search2",
  dimensions: { width: 40, height: 40 },
  content: `
    <g fill="currentColor" stroke="none">
        <path d="M37.71 37.71C37.32 38.1 36.69 38.1 36.3 37.71L26.57 27.99C27.07 27.55 27.54 27.08 27.98 26.58L37.71 36.31C38.1 36.68 38.1 37.32 37.71 37.71ZM2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30C8.28 30 2 23.72 2 16ZM39.12 34.88L29.23 24.99C30.98 22.42 32 19.33 32 16C32 7.18 24.82 0 16 0C7.18 0 0 7.18 0 16C0 24.82 7.18 32 16 32C19.33 32 22.42 30.98 24.99 29.23L34.88 39.12C35.46 39.71 36.23 40 37 40C37.77 40 38.54 39.71 39.12 39.12C40.29 37.95 40.29 36.05 39.12 34.88Z"/>
    </g>
  `
};
export {
  C as Search2
};
